const list3Points = require('./homepage/list-3-points');
const beingTogetherSlider = require('./homepage/being-together-slider');
const cheers = require('./homepage/cheers');
const homepage = () => {
    list3Points();
    beingTogetherSlider();
    cheers();
}

module.exports = homepage;